import * as React from 'react';

const ServicesSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 48 49" fill="none" {...props}>
        <path
            d="M1 42.924c7.776-.278 13.585 2.841 23 4.076 3.215.422 23-9.37 23-11.457 0-2.549-3.786-1.23-4.63-.978a68.976 68.976 0 01-6.415 1.602M17.633 38c3.494-1.807 14.495-.762 13.273-4.374-.547-1.614-7.155-.725-12.089-2.03-6.931-1.834-10.133-2.552-17.817.408"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="M25.5 1c.95 0 1.877.098 2.772.285a2.7 2.7 0 004.886 2.096 13.561 13.561 0 013.462 3.462 2.7 2.7 0 002.095 4.887c.187.893.285 1.82.285 2.77s-.098 1.877-.285 2.772a2.7 2.7 0 00-2.097 4.886 13.56 13.56 0 01-3.46 3.462 2.7 2.7 0 00-4.887 2.095c-.894.187-1.82.285-2.771.285-.95 0-1.877-.098-2.772-.285a2.7 2.7 0 00-4.886-2.096 13.56 13.56 0 01-3.462-3.462 2.7 2.7 0 00-2.095-4.887A13.526 13.526 0 0112 14.5c0-.95.098-1.877.285-2.772a2.7 2.7 0 002.096-4.886 13.56 13.56 0 013.462-3.462 2.7 2.7 0 004.887-2.095C23.623 1.098 24.55 1 25.5 1z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="M27.5 14.5a2 2 0 11-4 0 2 2 0 014 0z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="M32.5 14.5c0 3.864-3.135 7-7 7s-7-3.136-7-7 3.135-7 7-7 7 3.136 7 7z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

ServicesSvg.displayName = 'ServicesSvg';
export default ServicesSvg;
